import AddAppointmentFab from "./AddAppointmentFab";

export default AddAppointmentFab;
